// extracted by css-extract-rspack-plugin
export default {"products-sold":"BtDmYD","productsSold":"BtDmYD"};